// make validation rules accessible via this.$rules.ruleName
import validationHelper from '@/utils/validation.helper'

let rulesPlugin = {}
rulesPlugin.install = function (Vue) {
  Vue.prototype.$rules = { ...validationHelper }
}

export default rulesPlugin
